/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Invoices.Host.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from 'react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query'
import type {
  AllocationDimension,
  BillingInvoice,
  BillingInvoiceAdjustment,
  BillingInvoiceStatus,
  BillingTaxCode,
  CardinalityCheckResult,
  CompanyBillingTaxCode,
  ConversionPlanBundle,
  CostForecastRequest,
  CostForecastRequestedJob,
  DeleteCurSummary,
  ExportFilesProcessed,
  ForecastConfig,
  GetBillingInvoiceDownloadInvoiceFileParams,
  GetBillingInvoiceGetBillingInvoiceByIdParams,
  GetBillingInvoiceGetBillingInvoicesForCompanyParams,
  GetBillingInvoiceGetCompanyBillingTaxCodeParams,
  GetBillingInvoiceGetInvoiceProcessingLogEntriesParams,
  GetBillingInvoiceGetLastInvoiceUpdatedDateParams,
  GetBillingInvoiceGetSystemInvoiceAllocationRulesParams,
  GetInvoiceIngestionCreateAwsCurParams,
  GetInvoiceIngestionGetSchemaInfoParams,
  GetInvoiceRuleGetProcessingReportParams,
  GetInvoiceRuleGetSystemProcessingReportParams,
  InvoiceAllocationRule,
  InvoiceProcessData,
  InvoiceProcessingLogEntry,
  InvoiceProcessingReport,
  InvoiceSchemaInfo,
  InvoiceTaggingRule,
  ObjectQueryResult,
  PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsParams,
  PostBillingInvoiceGetAdminBillingInvoiceStatuses200One,
  PostBillingInvoiceGetAdminBillingInvoiceStatuses200Three,
  PostBillingInvoiceGetAdminBillingInvoiceStatuses200Two,
  PostBillingInvoiceGetBillingInvoiceStatuses200One,
  PostBillingInvoiceGetBillingInvoiceStatuses200Three,
  PostBillingInvoiceGetBillingInvoiceStatuses200Two,
  PostBillingInvoiceSaveBillingInvoiceAdjustmentsParams,
  PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsParams,
  PostBillingInvoiceSaveQuickbooksTokenFromCodeParams,
  PostBillingInvoiceSyncQuickbooksInvoiceParams,
  PostBillingInvoiceUploadInvoiceFileBody,
  PostBillingInvoiceUploadInvoiceFileParams,
  PostBillingRollupMultiQueryParams,
  PostBillingRollupQueryParams,
  PostBillingRollupStreamParams,
  PostCspInvoiceDataDigestContollerMultiQueryParams,
  PostCspInvoiceDataDigestContollerQueryParams,
  PostCspInvoiceDataDigestContollerStreamParams,
  PostCurDeleteParams,
  PostDailyRollupMultiQueryParams,
  PostDailyRollupQueryDailyResourceSpendParams,
  PostDailyRollupQueryMonthsParams,
  PostDailyRollupQueryParams,
  PostDailyRollupStreamParams,
  PostInvoiceIngestionIngestReducedBillingFilesParams,
  PostInvoiceIngestionIngestStagedFilesParams,
  PostMonthlyRollupMultiQueryParams,
  PostMonthlyRollupQueryParams,
  PostMonthlyRollupStreamParams,
  PostResaleCostMultiQueryParams,
  PostResaleCostQueryParams,
  PostResaleCostStreamParams,
  QbConnectionStatus,
  Query,
  TenantForecastRefreshNeededJob,
  UpdateQuickbooksInvoiceJob
} from './Invoices/model'
import { request } from '../Services/BasicApi';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getBillingInvoiceGetBillingInvoices = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<BillingInvoice[]>(
      {url: `/BillingInvoice/GetBillingInvoices`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetBillingInvoicesQueryKey = () => {
    return [`/BillingInvoice/GetBillingInvoices`] as const;
    }

    
export const getGetBillingInvoiceGetBillingInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoices>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoices>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetBillingInvoicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoices>>> = ({ signal }) => getBillingInvoiceGetBillingInvoices(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetBillingInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoices>>>
export type GetBillingInvoiceGetBillingInvoicesQueryError = unknown

export const useGetBillingInvoiceGetBillingInvoices = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoices>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoices>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetBillingInvoicesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBillingInvoiceGetCurrentMonthBillingInvoice = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<BillingInvoice>(
      {url: `/BillingInvoice/GetCurrentMonthBillingInvoice`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetCurrentMonthBillingInvoiceQueryKey = () => {
    return [`/BillingInvoice/GetCurrentMonthBillingInvoice`] as const;
    }

    
export const getGetBillingInvoiceGetCurrentMonthBillingInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetCurrentMonthBillingInvoice>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCurrentMonthBillingInvoice>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetCurrentMonthBillingInvoiceQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetCurrentMonthBillingInvoice>>> = ({ signal }) => getBillingInvoiceGetCurrentMonthBillingInvoice(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCurrentMonthBillingInvoice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetCurrentMonthBillingInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetCurrentMonthBillingInvoice>>>
export type GetBillingInvoiceGetCurrentMonthBillingInvoiceQueryError = unknown

export const useGetBillingInvoiceGetCurrentMonthBillingInvoice = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetCurrentMonthBillingInvoice>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCurrentMonthBillingInvoice>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetCurrentMonthBillingInvoiceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBillingInvoiceGetAllBillingInvoices = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<BillingInvoice[]>(
      {url: `/BillingInvoice/GetAllBillingInvoices`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetAllBillingInvoicesQueryKey = () => {
    return [`/BillingInvoice/GetAllBillingInvoices`] as const;
    }

    
export const getGetBillingInvoiceGetAllBillingInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetAllBillingInvoices>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetAllBillingInvoices>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetAllBillingInvoicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetAllBillingInvoices>>> = ({ signal }) => getBillingInvoiceGetAllBillingInvoices(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetAllBillingInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetAllBillingInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetAllBillingInvoices>>>
export type GetBillingInvoiceGetAllBillingInvoicesQueryError = unknown

export const useGetBillingInvoiceGetAllBillingInvoices = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetAllBillingInvoices>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetAllBillingInvoices>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetAllBillingInvoicesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBillingInvoiceGetBillingInvoiceById = (
    params?: GetBillingInvoiceGetBillingInvoiceByIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<BillingInvoice>(
      {url: `/BillingInvoice/GetBillingInvoiceById`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetBillingInvoiceByIdQueryKey = (params?: GetBillingInvoiceGetBillingInvoiceByIdParams,) => {
    return [`/BillingInvoice/GetBillingInvoiceById`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBillingInvoiceGetBillingInvoiceByIdQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoiceById>>, TError = unknown>(params?: GetBillingInvoiceGetBillingInvoiceByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoiceById>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetBillingInvoiceByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoiceById>>> = ({ signal }) => getBillingInvoiceGetBillingInvoiceById(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoiceById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetBillingInvoiceByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoiceById>>>
export type GetBillingInvoiceGetBillingInvoiceByIdQueryError = unknown

export const useGetBillingInvoiceGetBillingInvoiceById = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoiceById>>, TError = unknown>(
 params?: GetBillingInvoiceGetBillingInvoiceByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoiceById>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetBillingInvoiceByIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBillingInvoiceGetBillingInvoicesForCompany = (
    params?: GetBillingInvoiceGetBillingInvoicesForCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<BillingInvoice[]>(
      {url: `/BillingInvoice/GetBillingInvoicesForCompany`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetBillingInvoicesForCompanyQueryKey = (params?: GetBillingInvoiceGetBillingInvoicesForCompanyParams,) => {
    return [`/BillingInvoice/GetBillingInvoicesForCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBillingInvoiceGetBillingInvoicesForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoicesForCompany>>, TError = unknown>(params?: GetBillingInvoiceGetBillingInvoicesForCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoicesForCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetBillingInvoicesForCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoicesForCompany>>> = ({ signal }) => getBillingInvoiceGetBillingInvoicesForCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoicesForCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetBillingInvoicesForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoicesForCompany>>>
export type GetBillingInvoiceGetBillingInvoicesForCompanyQueryError = unknown

export const useGetBillingInvoiceGetBillingInvoicesForCompany = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoicesForCompany>>, TError = unknown>(
 params?: GetBillingInvoiceGetBillingInvoicesForCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingInvoicesForCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetBillingInvoicesForCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBillingInvoiceGetCompanyBillingTaxCodes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyBillingTaxCode[]>(
      {url: `/BillingInvoice/GetCompanyBillingTaxCodes`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetCompanyBillingTaxCodesQueryKey = () => {
    return [`/BillingInvoice/GetCompanyBillingTaxCodes`] as const;
    }

    
export const getGetBillingInvoiceGetCompanyBillingTaxCodesQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCodes>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCodes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetCompanyBillingTaxCodesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCodes>>> = ({ signal }) => getBillingInvoiceGetCompanyBillingTaxCodes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCodes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetCompanyBillingTaxCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCodes>>>
export type GetBillingInvoiceGetCompanyBillingTaxCodesQueryError = unknown

export const useGetBillingInvoiceGetCompanyBillingTaxCodes = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCodes>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCodes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetCompanyBillingTaxCodesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBillingInvoiceGetCompanyBillingTaxCode = (
    params?: GetBillingInvoiceGetCompanyBillingTaxCodeParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyBillingTaxCode>(
      {url: `/BillingInvoice/GetCompanyBillingTaxCode`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetCompanyBillingTaxCodeQueryKey = (params?: GetBillingInvoiceGetCompanyBillingTaxCodeParams,) => {
    return [`/BillingInvoice/GetCompanyBillingTaxCode`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBillingInvoiceGetCompanyBillingTaxCodeQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCode>>, TError = unknown>(params?: GetBillingInvoiceGetCompanyBillingTaxCodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCode>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetCompanyBillingTaxCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCode>>> = ({ signal }) => getBillingInvoiceGetCompanyBillingTaxCode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCode>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetCompanyBillingTaxCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCode>>>
export type GetBillingInvoiceGetCompanyBillingTaxCodeQueryError = unknown

export const useGetBillingInvoiceGetCompanyBillingTaxCode = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCode>>, TError = unknown>(
 params?: GetBillingInvoiceGetCompanyBillingTaxCodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetCompanyBillingTaxCode>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetCompanyBillingTaxCodeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBillingInvoiceGetBillingTaxCodes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<BillingTaxCode[]>(
      {url: `/BillingInvoice/GetBillingTaxCodes`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetBillingTaxCodesQueryKey = () => {
    return [`/BillingInvoice/GetBillingTaxCodes`] as const;
    }

    
export const getGetBillingInvoiceGetBillingTaxCodesQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetBillingTaxCodes>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingTaxCodes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetBillingTaxCodesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetBillingTaxCodes>>> = ({ signal }) => getBillingInvoiceGetBillingTaxCodes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingTaxCodes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetBillingTaxCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetBillingTaxCodes>>>
export type GetBillingInvoiceGetBillingTaxCodesQueryError = unknown

export const useGetBillingInvoiceGetBillingTaxCodes = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetBillingTaxCodes>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetBillingTaxCodes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetBillingTaxCodesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postBillingInvoiceGetBillingInvoiceStatuses = (
    postBillingInvoiceGetBillingInvoiceStatusesBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostBillingInvoiceGetBillingInvoiceStatuses200One | PostBillingInvoiceGetBillingInvoiceStatuses200Two | PostBillingInvoiceGetBillingInvoiceStatuses200Three>(
      {url: `/BillingInvoice/GetBillingInvoiceStatuses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postBillingInvoiceGetBillingInvoiceStatusesBody
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceGetBillingInvoiceStatusesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetBillingInvoiceStatuses>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetBillingInvoiceStatuses>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceGetBillingInvoiceStatuses>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceGetBillingInvoiceStatuses(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceGetBillingInvoiceStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceGetBillingInvoiceStatuses>>>
    export type PostBillingInvoiceGetBillingInvoiceStatusesMutationBody = number[]
    export type PostBillingInvoiceGetBillingInvoiceStatusesMutationError = unknown

    export const usePostBillingInvoiceGetBillingInvoiceStatuses = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetBillingInvoiceStatuses>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceGetBillingInvoiceStatuses>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceGetBillingInvoiceStatusesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceGetAdminBillingInvoiceStatuses = (
    postBillingInvoiceGetAdminBillingInvoiceStatusesBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostBillingInvoiceGetAdminBillingInvoiceStatuses200One | PostBillingInvoiceGetAdminBillingInvoiceStatuses200Two | PostBillingInvoiceGetAdminBillingInvoiceStatuses200Three>(
      {url: `/BillingInvoice/GetAdminBillingInvoiceStatuses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postBillingInvoiceGetAdminBillingInvoiceStatusesBody
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceGetAdminBillingInvoiceStatusesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceStatuses>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceStatuses>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceStatuses>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceGetAdminBillingInvoiceStatuses(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceGetAdminBillingInvoiceStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceStatuses>>>
    export type PostBillingInvoiceGetAdminBillingInvoiceStatusesMutationBody = number[]
    export type PostBillingInvoiceGetAdminBillingInvoiceStatusesMutationError = unknown

    export const usePostBillingInvoiceGetAdminBillingInvoiceStatuses = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceStatuses>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceStatuses>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceGetAdminBillingInvoiceStatusesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses = (
    postBillingInvoiceGetAdminBillingInvoiceHistoricalStatusesBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BillingInvoiceStatus[]>(
      {url: `/BillingInvoice/GetAdminBillingInvoiceHistoricalStatuses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postBillingInvoiceGetAdminBillingInvoiceHistoricalStatusesBody
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceGetAdminBillingInvoiceHistoricalStatusesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceGetAdminBillingInvoiceHistoricalStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses>>>
    export type PostBillingInvoiceGetAdminBillingInvoiceHistoricalStatusesMutationBody = number[]
    export type PostBillingInvoiceGetAdminBillingInvoiceHistoricalStatusesMutationError = unknown

    export const usePostBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceGetAdminBillingInvoiceHistoricalStatuses>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceGetAdminBillingInvoiceHistoricalStatusesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceSaveBillingInvoice = (
    billingInvoice: BillingInvoice,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BillingInvoice>(
      {url: `/BillingInvoice/SaveBillingInvoice`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingInvoice
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSaveBillingInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoice>>, TError,{data: BillingInvoice}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoice>>, TError,{data: BillingInvoice}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoice>>, {data: BillingInvoice}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceSaveBillingInvoice(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSaveBillingInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoice>>>
    export type PostBillingInvoiceSaveBillingInvoiceMutationBody = BillingInvoice
    export type PostBillingInvoiceSaveBillingInvoiceMutationError = unknown

    export const usePostBillingInvoiceSaveBillingInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoice>>, TError,{data: BillingInvoice}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoice>>,
        TError,
        {data: BillingInvoice},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSaveBillingInvoiceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceUpdateBillingInvoiceStatus = (
    billingInvoiceStatus: BillingInvoiceStatus,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BillingInvoiceStatus>(
      {url: `/BillingInvoice/UpdateBillingInvoiceStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingInvoiceStatus
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceUpdateBillingInvoiceStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceUpdateBillingInvoiceStatus>>, TError,{data: BillingInvoiceStatus}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceUpdateBillingInvoiceStatus>>, TError,{data: BillingInvoiceStatus}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceUpdateBillingInvoiceStatus>>, {data: BillingInvoiceStatus}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceUpdateBillingInvoiceStatus(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceUpdateBillingInvoiceStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceUpdateBillingInvoiceStatus>>>
    export type PostBillingInvoiceUpdateBillingInvoiceStatusMutationBody = BillingInvoiceStatus
    export type PostBillingInvoiceUpdateBillingInvoiceStatusMutationError = unknown

    export const usePostBillingInvoiceUpdateBillingInvoiceStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceUpdateBillingInvoiceStatus>>, TError,{data: BillingInvoiceStatus}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceUpdateBillingInvoiceStatus>>,
        TError,
        {data: BillingInvoiceStatus},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceUpdateBillingInvoiceStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceSaveBillingInvoiceAdjustments = (
    billingInvoiceAdjustment: BillingInvoiceAdjustment[],
    params?: PostBillingInvoiceSaveBillingInvoiceAdjustmentsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BillingInvoiceAdjustment[]>(
      {url: `/BillingInvoice/SaveBillingInvoiceAdjustments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingInvoiceAdjustment,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSaveBillingInvoiceAdjustmentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceSaveBillingInvoiceAdjustmentsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceSaveBillingInvoiceAdjustmentsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoiceAdjustments>>, {data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceSaveBillingInvoiceAdjustmentsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postBillingInvoiceSaveBillingInvoiceAdjustments(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSaveBillingInvoiceAdjustmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoiceAdjustments>>>
    export type PostBillingInvoiceSaveBillingInvoiceAdjustmentsMutationBody = BillingInvoiceAdjustment[]
    export type PostBillingInvoiceSaveBillingInvoiceAdjustmentsMutationError = unknown

    export const usePostBillingInvoiceSaveBillingInvoiceAdjustments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceSaveBillingInvoiceAdjustmentsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSaveBillingInvoiceAdjustments>>,
        TError,
        {data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceSaveBillingInvoiceAdjustmentsParams},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSaveBillingInvoiceAdjustmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceSaveCopiedBillingInvoiceAdjustments = (
    billingInvoiceAdjustment: BillingInvoiceAdjustment,
    params?: PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BillingInvoice>(
      {url: `/BillingInvoice/SaveCopiedBillingInvoiceAdjustments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingInvoiceAdjustment,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCopiedBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment;params?: PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCopiedBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment;params?: PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSaveCopiedBillingInvoiceAdjustments>>, {data: BillingInvoiceAdjustment;params?: PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postBillingInvoiceSaveCopiedBillingInvoiceAdjustments(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSaveCopiedBillingInvoiceAdjustments>>>
    export type PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsMutationBody = BillingInvoiceAdjustment
    export type PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsMutationError = unknown

    export const usePostBillingInvoiceSaveCopiedBillingInvoiceAdjustments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCopiedBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment;params?: PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSaveCopiedBillingInvoiceAdjustments>>,
        TError,
        {data: BillingInvoiceAdjustment;params?: PostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsParams},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSaveCopiedBillingInvoiceAdjustmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceCopyAllBillingInvoiceAdjustments = (
    billingInvoiceAdjustment: BillingInvoiceAdjustment[],
    params?: PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BillingInvoice>(
      {url: `/BillingInvoice/CopyAllBillingInvoiceAdjustments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingInvoiceAdjustment,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceCopyAllBillingInvoiceAdjustmentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceCopyAllBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceCopyAllBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceCopyAllBillingInvoiceAdjustments>>, {data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postBillingInvoiceCopyAllBillingInvoiceAdjustments(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceCopyAllBillingInvoiceAdjustments>>>
    export type PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsMutationBody = BillingInvoiceAdjustment[]
    export type PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsMutationError = unknown

    export const usePostBillingInvoiceCopyAllBillingInvoiceAdjustments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceCopyAllBillingInvoiceAdjustments>>, TError,{data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceCopyAllBillingInvoiceAdjustments>>,
        TError,
        {data: BillingInvoiceAdjustment[];params?: PostBillingInvoiceCopyAllBillingInvoiceAdjustmentsParams},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceCopyAllBillingInvoiceAdjustmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceSaveCompanyBillingTaxCode = (
    companyBillingTaxCode: CompanyBillingTaxCode,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyBillingTaxCode>(
      {url: `/BillingInvoice/SaveCompanyBillingTaxCode`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyBillingTaxCode
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSaveCompanyBillingTaxCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCode>>, TError,{data: CompanyBillingTaxCode}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCode>>, TError,{data: CompanyBillingTaxCode}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCode>>, {data: CompanyBillingTaxCode}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceSaveCompanyBillingTaxCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSaveCompanyBillingTaxCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCode>>>
    export type PostBillingInvoiceSaveCompanyBillingTaxCodeMutationBody = CompanyBillingTaxCode
    export type PostBillingInvoiceSaveCompanyBillingTaxCodeMutationError = unknown

    export const usePostBillingInvoiceSaveCompanyBillingTaxCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCode>>, TError,{data: CompanyBillingTaxCode}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCode>>,
        TError,
        {data: CompanyBillingTaxCode},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSaveCompanyBillingTaxCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceSaveCompanyBillingTaxCodes = (
    companyBillingTaxCode: CompanyBillingTaxCode[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyBillingTaxCode[]>(
      {url: `/BillingInvoice/SaveCompanyBillingTaxCodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyBillingTaxCode
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSaveCompanyBillingTaxCodesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCodes>>, TError,{data: CompanyBillingTaxCode[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCodes>>, TError,{data: CompanyBillingTaxCode[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCodes>>, {data: CompanyBillingTaxCode[]}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceSaveCompanyBillingTaxCodes(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSaveCompanyBillingTaxCodesMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCodes>>>
    export type PostBillingInvoiceSaveCompanyBillingTaxCodesMutationBody = CompanyBillingTaxCode[]
    export type PostBillingInvoiceSaveCompanyBillingTaxCodesMutationError = unknown

    export const usePostBillingInvoiceSaveCompanyBillingTaxCodes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCodes>>, TError,{data: CompanyBillingTaxCode[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSaveCompanyBillingTaxCodes>>,
        TError,
        {data: CompanyBillingTaxCode[]},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSaveCompanyBillingTaxCodesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceSaveBillingTaxCode = (
    billingTaxCode: BillingTaxCode,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<BillingTaxCode>(
      {url: `/BillingInvoice/SaveBillingTaxCode`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingTaxCode
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSaveBillingTaxCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCode>>, TError,{data: BillingTaxCode}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCode>>, TError,{data: BillingTaxCode}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCode>>, {data: BillingTaxCode}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceSaveBillingTaxCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSaveBillingTaxCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCode>>>
    export type PostBillingInvoiceSaveBillingTaxCodeMutationBody = BillingTaxCode
    export type PostBillingInvoiceSaveBillingTaxCodeMutationError = unknown

    export const usePostBillingInvoiceSaveBillingTaxCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCode>>, TError,{data: BillingTaxCode}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCode>>,
        TError,
        {data: BillingTaxCode},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSaveBillingTaxCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceSaveBillingTaxCodes = (
    billingTaxCode: BillingTaxCode[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/BillingInvoice/SaveBillingTaxCodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingTaxCode
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSaveBillingTaxCodesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCodes>>, TError,{data: BillingTaxCode[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCodes>>, TError,{data: BillingTaxCode[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCodes>>, {data: BillingTaxCode[]}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceSaveBillingTaxCodes(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSaveBillingTaxCodesMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCodes>>>
    export type PostBillingInvoiceSaveBillingTaxCodesMutationBody = BillingTaxCode[]
    export type PostBillingInvoiceSaveBillingTaxCodesMutationError = unknown

    export const usePostBillingInvoiceSaveBillingTaxCodes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCodes>>, TError,{data: BillingTaxCode[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSaveBillingTaxCodes>>,
        TError,
        {data: BillingTaxCode[]},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSaveBillingTaxCodesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getBillingInvoiceGetSystemInvoiceAllocationRules = (
    params?: GetBillingInvoiceGetSystemInvoiceAllocationRulesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceAllocationRule[]>(
      {url: `/BillingInvoice/GetSystemInvoiceAllocationRules`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetSystemInvoiceAllocationRulesQueryKey = (params?: GetBillingInvoiceGetSystemInvoiceAllocationRulesParams,) => {
    return [`/BillingInvoice/GetSystemInvoiceAllocationRules`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBillingInvoiceGetSystemInvoiceAllocationRulesQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetSystemInvoiceAllocationRules>>, TError = unknown>(params?: GetBillingInvoiceGetSystemInvoiceAllocationRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetSystemInvoiceAllocationRules>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetSystemInvoiceAllocationRulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetSystemInvoiceAllocationRules>>> = ({ signal }) => getBillingInvoiceGetSystemInvoiceAllocationRules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetSystemInvoiceAllocationRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetSystemInvoiceAllocationRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetSystemInvoiceAllocationRules>>>
export type GetBillingInvoiceGetSystemInvoiceAllocationRulesQueryError = unknown

export const useGetBillingInvoiceGetSystemInvoiceAllocationRules = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetSystemInvoiceAllocationRules>>, TError = unknown>(
 params?: GetBillingInvoiceGetSystemInvoiceAllocationRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetSystemInvoiceAllocationRules>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetSystemInvoiceAllocationRulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postBillingInvoiceUploadInvoiceFile = (
    postBillingInvoiceUploadInvoiceFileBody: PostBillingInvoiceUploadInvoiceFileBody,
    params?: PostBillingInvoiceUploadInvoiceFileParams,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(postBillingInvoiceUploadInvoiceFileBody.file !== undefined) {
 formData.append('file', postBillingInvoiceUploadInvoiceFileBody.file)
 }

      return request<void>(
      {url: `/BillingInvoice/UploadInvoiceFile`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceUploadInvoiceFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceUploadInvoiceFile>>, TError,{data: PostBillingInvoiceUploadInvoiceFileBody;params?: PostBillingInvoiceUploadInvoiceFileParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceUploadInvoiceFile>>, TError,{data: PostBillingInvoiceUploadInvoiceFileBody;params?: PostBillingInvoiceUploadInvoiceFileParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceUploadInvoiceFile>>, {data: PostBillingInvoiceUploadInvoiceFileBody;params?: PostBillingInvoiceUploadInvoiceFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postBillingInvoiceUploadInvoiceFile(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceUploadInvoiceFileMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceUploadInvoiceFile>>>
    export type PostBillingInvoiceUploadInvoiceFileMutationBody = PostBillingInvoiceUploadInvoiceFileBody
    export type PostBillingInvoiceUploadInvoiceFileMutationError = unknown

    export const usePostBillingInvoiceUploadInvoiceFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceUploadInvoiceFile>>, TError,{data: PostBillingInvoiceUploadInvoiceFileBody;params?: PostBillingInvoiceUploadInvoiceFileParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceUploadInvoiceFile>>,
        TError,
        {data: PostBillingInvoiceUploadInvoiceFileBody;params?: PostBillingInvoiceUploadInvoiceFileParams},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceUploadInvoiceFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getBillingInvoiceDownloadInvoiceFile = (
    params?: GetBillingInvoiceDownloadInvoiceFileParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/BillingInvoice/DownloadInvoiceFile`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceDownloadInvoiceFileQueryKey = (params?: GetBillingInvoiceDownloadInvoiceFileParams,) => {
    return [`/BillingInvoice/DownloadInvoiceFile`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBillingInvoiceDownloadInvoiceFileQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceDownloadInvoiceFile>>, TError = unknown>(params?: GetBillingInvoiceDownloadInvoiceFileParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceDownloadInvoiceFile>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceDownloadInvoiceFileQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceDownloadInvoiceFile>>> = ({ signal }) => getBillingInvoiceDownloadInvoiceFile(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceDownloadInvoiceFile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceDownloadInvoiceFileQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceDownloadInvoiceFile>>>
export type GetBillingInvoiceDownloadInvoiceFileQueryError = unknown

export const useGetBillingInvoiceDownloadInvoiceFile = <TData = Awaited<ReturnType<typeof getBillingInvoiceDownloadInvoiceFile>>, TError = unknown>(
 params?: GetBillingInvoiceDownloadInvoiceFileParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceDownloadInvoiceFile>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceDownloadInvoiceFileQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postBillingInvoiceRerunInvoiceProcessing = (
    billingInvoice: BillingInvoice,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/BillingInvoice/RerunInvoiceProcessing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingInvoice
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceRerunInvoiceProcessingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceRerunInvoiceProcessing>>, TError,{data: BillingInvoice}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceRerunInvoiceProcessing>>, TError,{data: BillingInvoice}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceRerunInvoiceProcessing>>, {data: BillingInvoice}> = (props) => {
          const {data} = props ?? {};

          return  postBillingInvoiceRerunInvoiceProcessing(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceRerunInvoiceProcessingMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceRerunInvoiceProcessing>>>
    export type PostBillingInvoiceRerunInvoiceProcessingMutationBody = BillingInvoice
    export type PostBillingInvoiceRerunInvoiceProcessingMutationError = unknown

    export const usePostBillingInvoiceRerunInvoiceProcessing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceRerunInvoiceProcessing>>, TError,{data: BillingInvoice}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceRerunInvoiceProcessing>>,
        TError,
        {data: BillingInvoice},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceRerunInvoiceProcessingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getBillingInvoiceGetLastInvoiceUpdatedDate = (
    params?: GetBillingInvoiceGetLastInvoiceUpdatedDateParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceProcessingLogEntry>(
      {url: `/BillingInvoice/GetLastInvoiceUpdatedDate`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetLastInvoiceUpdatedDateQueryKey = (params?: GetBillingInvoiceGetLastInvoiceUpdatedDateParams,) => {
    return [`/BillingInvoice/GetLastInvoiceUpdatedDate`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBillingInvoiceGetLastInvoiceUpdatedDateQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetLastInvoiceUpdatedDate>>, TError = unknown>(params?: GetBillingInvoiceGetLastInvoiceUpdatedDateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetLastInvoiceUpdatedDate>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetLastInvoiceUpdatedDateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetLastInvoiceUpdatedDate>>> = ({ signal }) => getBillingInvoiceGetLastInvoiceUpdatedDate(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetLastInvoiceUpdatedDate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetLastInvoiceUpdatedDateQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetLastInvoiceUpdatedDate>>>
export type GetBillingInvoiceGetLastInvoiceUpdatedDateQueryError = unknown

export const useGetBillingInvoiceGetLastInvoiceUpdatedDate = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetLastInvoiceUpdatedDate>>, TError = unknown>(
 params?: GetBillingInvoiceGetLastInvoiceUpdatedDateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetLastInvoiceUpdatedDate>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetLastInvoiceUpdatedDateQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBillingInvoiceGetInvoiceProcessingLogEntries = (
    params?: GetBillingInvoiceGetInvoiceProcessingLogEntriesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceProcessingLogEntry[]>(
      {url: `/BillingInvoice/GetInvoiceProcessingLogEntries`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetInvoiceProcessingLogEntriesQueryKey = (params?: GetBillingInvoiceGetInvoiceProcessingLogEntriesParams,) => {
    return [`/BillingInvoice/GetInvoiceProcessingLogEntries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBillingInvoiceGetInvoiceProcessingLogEntriesQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetInvoiceProcessingLogEntries>>, TError = unknown>(params?: GetBillingInvoiceGetInvoiceProcessingLogEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetInvoiceProcessingLogEntries>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetInvoiceProcessingLogEntriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetInvoiceProcessingLogEntries>>> = ({ signal }) => getBillingInvoiceGetInvoiceProcessingLogEntries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetInvoiceProcessingLogEntries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetInvoiceProcessingLogEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetInvoiceProcessingLogEntries>>>
export type GetBillingInvoiceGetInvoiceProcessingLogEntriesQueryError = unknown

export const useGetBillingInvoiceGetInvoiceProcessingLogEntries = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetInvoiceProcessingLogEntries>>, TError = unknown>(
 params?: GetBillingInvoiceGetInvoiceProcessingLogEntriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetInvoiceProcessingLogEntries>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetInvoiceProcessingLogEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postBillingInvoiceSyncQuickbooksInvoice = (
    params?: PostBillingInvoiceSyncQuickbooksInvoiceParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<UpdateQuickbooksInvoiceJob>(
      {url: `/BillingInvoice/SyncQuickbooksInvoice`, method: 'POST',
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSyncQuickbooksInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSyncQuickbooksInvoice>>, TError,{params?: PostBillingInvoiceSyncQuickbooksInvoiceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSyncQuickbooksInvoice>>, TError,{params?: PostBillingInvoiceSyncQuickbooksInvoiceParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSyncQuickbooksInvoice>>, {params?: PostBillingInvoiceSyncQuickbooksInvoiceParams}> = (props) => {
          const {params} = props ?? {};

          return  postBillingInvoiceSyncQuickbooksInvoice(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSyncQuickbooksInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSyncQuickbooksInvoice>>>
    
    export type PostBillingInvoiceSyncQuickbooksInvoiceMutationError = unknown

    export const usePostBillingInvoiceSyncQuickbooksInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSyncQuickbooksInvoice>>, TError,{params?: PostBillingInvoiceSyncQuickbooksInvoiceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSyncQuickbooksInvoice>>,
        TError,
        {params?: PostBillingInvoiceSyncQuickbooksInvoiceParams},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSyncQuickbooksInvoiceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingInvoiceGetQuickbooksConnectionUrl = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/BillingInvoice/GetQuickbooksConnectionUrl`, method: 'POST'
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceGetQuickbooksConnectionUrlMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetQuickbooksConnectionUrl>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetQuickbooksConnectionUrl>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceGetQuickbooksConnectionUrl>>, void> = () => {
          

          return  postBillingInvoiceGetQuickbooksConnectionUrl(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceGetQuickbooksConnectionUrlMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceGetQuickbooksConnectionUrl>>>
    
    export type PostBillingInvoiceGetQuickbooksConnectionUrlMutationError = unknown

    export const usePostBillingInvoiceGetQuickbooksConnectionUrl = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceGetQuickbooksConnectionUrl>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceGetQuickbooksConnectionUrl>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceGetQuickbooksConnectionUrlMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getBillingInvoiceGetQuickbooksConnectionStatus = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<QbConnectionStatus>(
      {url: `/BillingInvoice/GetQuickbooksConnectionStatus`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetBillingInvoiceGetQuickbooksConnectionStatusQueryKey = () => {
    return [`/BillingInvoice/GetQuickbooksConnectionStatus`] as const;
    }

    
export const getGetBillingInvoiceGetQuickbooksConnectionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetQuickbooksConnectionStatus>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetQuickbooksConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoiceGetQuickbooksConnectionStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoiceGetQuickbooksConnectionStatus>>> = ({ signal }) => getBillingInvoiceGetQuickbooksConnectionStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetQuickbooksConnectionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingInvoiceGetQuickbooksConnectionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoiceGetQuickbooksConnectionStatus>>>
export type GetBillingInvoiceGetQuickbooksConnectionStatusQueryError = unknown

export const useGetBillingInvoiceGetQuickbooksConnectionStatus = <TData = Awaited<ReturnType<typeof getBillingInvoiceGetQuickbooksConnectionStatus>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoiceGetQuickbooksConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBillingInvoiceGetQuickbooksConnectionStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postBillingInvoiceSaveQuickbooksTokenFromCode = (
    params?: PostBillingInvoiceSaveQuickbooksTokenFromCodeParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/BillingInvoice/SaveQuickbooksTokenFromCode`, method: 'POST',
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingInvoiceSaveQuickbooksTokenFromCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveQuickbooksTokenFromCode>>, TError,{params?: PostBillingInvoiceSaveQuickbooksTokenFromCodeParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveQuickbooksTokenFromCode>>, TError,{params?: PostBillingInvoiceSaveQuickbooksTokenFromCodeParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingInvoiceSaveQuickbooksTokenFromCode>>, {params?: PostBillingInvoiceSaveQuickbooksTokenFromCodeParams}> = (props) => {
          const {params} = props ?? {};

          return  postBillingInvoiceSaveQuickbooksTokenFromCode(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingInvoiceSaveQuickbooksTokenFromCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingInvoiceSaveQuickbooksTokenFromCode>>>
    
    export type PostBillingInvoiceSaveQuickbooksTokenFromCodeMutationError = unknown

    export const usePostBillingInvoiceSaveQuickbooksTokenFromCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingInvoiceSaveQuickbooksTokenFromCode>>, TError,{params?: PostBillingInvoiceSaveQuickbooksTokenFromCodeParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingInvoiceSaveQuickbooksTokenFromCode>>,
        TError,
        {params?: PostBillingInvoiceSaveQuickbooksTokenFromCodeParams},
        TContext
      > => {

      const mutationOptions = getPostBillingInvoiceSaveQuickbooksTokenFromCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingRollupQuery = (
    query: Query,
    params?: PostBillingRollupQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/BillingRollup/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingRollupQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupQuery>>, TError,{data: Query;params?: PostBillingRollupQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupQuery>>, TError,{data: Query;params?: PostBillingRollupQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingRollupQuery>>, {data: Query;params?: PostBillingRollupQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postBillingRollupQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingRollupQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingRollupQuery>>>
    export type PostBillingRollupQueryMutationBody = Query
    export type PostBillingRollupQueryMutationError = unknown

    export const usePostBillingRollupQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupQuery>>, TError,{data: Query;params?: PostBillingRollupQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingRollupQuery>>,
        TError,
        {data: Query;params?: PostBillingRollupQueryParams},
        TContext
      > => {

      const mutationOptions = getPostBillingRollupQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingRollupStream = (
    query: Query,
    params?: PostBillingRollupStreamParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/BillingRollup/Stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingRollupStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupStream>>, TError,{data: Query;params?: PostBillingRollupStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupStream>>, TError,{data: Query;params?: PostBillingRollupStreamParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingRollupStream>>, {data: Query;params?: PostBillingRollupStreamParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postBillingRollupStream(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingRollupStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingRollupStream>>>
    export type PostBillingRollupStreamMutationBody = Query
    export type PostBillingRollupStreamMutationError = unknown

    export const usePostBillingRollupStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupStream>>, TError,{data: Query;params?: PostBillingRollupStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingRollupStream>>,
        TError,
        {data: Query;params?: PostBillingRollupStreamParams},
        TContext
      > => {

      const mutationOptions = getPostBillingRollupStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postBillingRollupMultiQuery = (
    query: Query[],
    params?: PostBillingRollupMultiQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult[]>(
      {url: `/BillingRollup/MultiQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostBillingRollupMultiQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupMultiQuery>>, TError,{data: Query[];params?: PostBillingRollupMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupMultiQuery>>, TError,{data: Query[];params?: PostBillingRollupMultiQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBillingRollupMultiQuery>>, {data: Query[];params?: PostBillingRollupMultiQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postBillingRollupMultiQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBillingRollupMultiQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postBillingRollupMultiQuery>>>
    export type PostBillingRollupMultiQueryMutationBody = Query[]
    export type PostBillingRollupMultiQueryMutationError = unknown

    export const usePostBillingRollupMultiQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBillingRollupMultiQuery>>, TError,{data: Query[];params?: PostBillingRollupMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postBillingRollupMultiQuery>>,
        TError,
        {data: Query[];params?: PostBillingRollupMultiQueryParams},
        TContext
      > => {

      const mutationOptions = getPostBillingRollupMultiQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCspInvoiceDataDigestContollerQuery = (
    query: Query,
    params?: PostCspInvoiceDataDigestContollerQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/CspInvoiceDataDigestContoller/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostCspInvoiceDataDigestContollerQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerQuery>>, TError,{data: Query;params?: PostCspInvoiceDataDigestContollerQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerQuery>>, TError,{data: Query;params?: PostCspInvoiceDataDigestContollerQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerQuery>>, {data: Query;params?: PostCspInvoiceDataDigestContollerQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCspInvoiceDataDigestContollerQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspInvoiceDataDigestContollerQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerQuery>>>
    export type PostCspInvoiceDataDigestContollerQueryMutationBody = Query
    export type PostCspInvoiceDataDigestContollerQueryMutationError = unknown

    export const usePostCspInvoiceDataDigestContollerQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerQuery>>, TError,{data: Query;params?: PostCspInvoiceDataDigestContollerQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerQuery>>,
        TError,
        {data: Query;params?: PostCspInvoiceDataDigestContollerQueryParams},
        TContext
      > => {

      const mutationOptions = getPostCspInvoiceDataDigestContollerQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCspInvoiceDataDigestContollerMultiQuery = (
    query: Query[],
    params?: PostCspInvoiceDataDigestContollerMultiQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult[]>(
      {url: `/CspInvoiceDataDigestContoller/MultiQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostCspInvoiceDataDigestContollerMultiQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerMultiQuery>>, TError,{data: Query[];params?: PostCspInvoiceDataDigestContollerMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerMultiQuery>>, TError,{data: Query[];params?: PostCspInvoiceDataDigestContollerMultiQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerMultiQuery>>, {data: Query[];params?: PostCspInvoiceDataDigestContollerMultiQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCspInvoiceDataDigestContollerMultiQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspInvoiceDataDigestContollerMultiQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerMultiQuery>>>
    export type PostCspInvoiceDataDigestContollerMultiQueryMutationBody = Query[]
    export type PostCspInvoiceDataDigestContollerMultiQueryMutationError = unknown

    export const usePostCspInvoiceDataDigestContollerMultiQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerMultiQuery>>, TError,{data: Query[];params?: PostCspInvoiceDataDigestContollerMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerMultiQuery>>,
        TError,
        {data: Query[];params?: PostCspInvoiceDataDigestContollerMultiQueryParams},
        TContext
      > => {

      const mutationOptions = getPostCspInvoiceDataDigestContollerMultiQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCspInvoiceDataDigestContollerStream = (
    query: Query,
    params?: PostCspInvoiceDataDigestContollerStreamParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/CspInvoiceDataDigestContoller/Stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostCspInvoiceDataDigestContollerStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerStream>>, TError,{data: Query;params?: PostCspInvoiceDataDigestContollerStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerStream>>, TError,{data: Query;params?: PostCspInvoiceDataDigestContollerStreamParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerStream>>, {data: Query;params?: PostCspInvoiceDataDigestContollerStreamParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCspInvoiceDataDigestContollerStream(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspInvoiceDataDigestContollerStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerStream>>>
    export type PostCspInvoiceDataDigestContollerStreamMutationBody = Query
    export type PostCspInvoiceDataDigestContollerStreamMutationError = unknown

    export const usePostCspInvoiceDataDigestContollerStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerStream>>, TError,{data: Query;params?: PostCspInvoiceDataDigestContollerStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspInvoiceDataDigestContollerStream>>,
        TError,
        {data: Query;params?: PostCspInvoiceDataDigestContollerStreamParams},
        TContext
      > => {

      const mutationOptions = getPostCspInvoiceDataDigestContollerStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCurDelete = (
    params?: PostCurDeleteParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<DeleteCurSummary>(
      {url: `/Cur/Delete`, method: 'POST',
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostCurDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCurDelete>>, TError,{params?: PostCurDeleteParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCurDelete>>, TError,{params?: PostCurDeleteParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCurDelete>>, {params?: PostCurDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  postCurDelete(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCurDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postCurDelete>>>
    
    export type PostCurDeleteMutationError = unknown

    export const usePostCurDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCurDelete>>, TError,{params?: PostCurDeleteParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCurDelete>>,
        TError,
        {params?: PostCurDeleteParams},
        TContext
      > => {

      const mutationOptions = getPostCurDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDailyRollupQuery = (
    query: Query,
    params?: PostDailyRollupQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/DailyRollup/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostDailyRollupQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQuery>>, TError,{data: Query;params?: PostDailyRollupQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQuery>>, TError,{data: Query;params?: PostDailyRollupQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDailyRollupQuery>>, {data: Query;params?: PostDailyRollupQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postDailyRollupQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDailyRollupQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postDailyRollupQuery>>>
    export type PostDailyRollupQueryMutationBody = Query
    export type PostDailyRollupQueryMutationError = unknown

    export const usePostDailyRollupQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQuery>>, TError,{data: Query;params?: PostDailyRollupQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDailyRollupQuery>>,
        TError,
        {data: Query;params?: PostDailyRollupQueryParams},
        TContext
      > => {

      const mutationOptions = getPostDailyRollupQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDailyRollupQueryMonths = (
    query: Query,
    params?: PostDailyRollupQueryMonthsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/DailyRollup/QueryMonths`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostDailyRollupQueryMonthsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQueryMonths>>, TError,{data: Query;params?: PostDailyRollupQueryMonthsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQueryMonths>>, TError,{data: Query;params?: PostDailyRollupQueryMonthsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDailyRollupQueryMonths>>, {data: Query;params?: PostDailyRollupQueryMonthsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postDailyRollupQueryMonths(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDailyRollupQueryMonthsMutationResult = NonNullable<Awaited<ReturnType<typeof postDailyRollupQueryMonths>>>
    export type PostDailyRollupQueryMonthsMutationBody = Query
    export type PostDailyRollupQueryMonthsMutationError = unknown

    export const usePostDailyRollupQueryMonths = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQueryMonths>>, TError,{data: Query;params?: PostDailyRollupQueryMonthsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDailyRollupQueryMonths>>,
        TError,
        {data: Query;params?: PostDailyRollupQueryMonthsParams},
        TContext
      > => {

      const mutationOptions = getPostDailyRollupQueryMonthsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDailyRollupStream = (
    query: Query,
    params?: PostDailyRollupStreamParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/DailyRollup/Stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostDailyRollupStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupStream>>, TError,{data: Query;params?: PostDailyRollupStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupStream>>, TError,{data: Query;params?: PostDailyRollupStreamParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDailyRollupStream>>, {data: Query;params?: PostDailyRollupStreamParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postDailyRollupStream(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDailyRollupStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postDailyRollupStream>>>
    export type PostDailyRollupStreamMutationBody = Query
    export type PostDailyRollupStreamMutationError = unknown

    export const usePostDailyRollupStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupStream>>, TError,{data: Query;params?: PostDailyRollupStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDailyRollupStream>>,
        TError,
        {data: Query;params?: PostDailyRollupStreamParams},
        TContext
      > => {

      const mutationOptions = getPostDailyRollupStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDailyRollupQueryDailyResourceSpend = (
    query: Query,
    params?: PostDailyRollupQueryDailyResourceSpendParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/DailyRollup/QueryDailyResourceSpend`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostDailyRollupQueryDailyResourceSpendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQueryDailyResourceSpend>>, TError,{data: Query;params?: PostDailyRollupQueryDailyResourceSpendParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQueryDailyResourceSpend>>, TError,{data: Query;params?: PostDailyRollupQueryDailyResourceSpendParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDailyRollupQueryDailyResourceSpend>>, {data: Query;params?: PostDailyRollupQueryDailyResourceSpendParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postDailyRollupQueryDailyResourceSpend(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDailyRollupQueryDailyResourceSpendMutationResult = NonNullable<Awaited<ReturnType<typeof postDailyRollupQueryDailyResourceSpend>>>
    export type PostDailyRollupQueryDailyResourceSpendMutationBody = Query
    export type PostDailyRollupQueryDailyResourceSpendMutationError = unknown

    export const usePostDailyRollupQueryDailyResourceSpend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupQueryDailyResourceSpend>>, TError,{data: Query;params?: PostDailyRollupQueryDailyResourceSpendParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDailyRollupQueryDailyResourceSpend>>,
        TError,
        {data: Query;params?: PostDailyRollupQueryDailyResourceSpendParams},
        TContext
      > => {

      const mutationOptions = getPostDailyRollupQueryDailyResourceSpendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDailyRollupMultiQuery = (
    query: Query[],
    params?: PostDailyRollupMultiQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult[]>(
      {url: `/DailyRollup/MultiQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostDailyRollupMultiQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupMultiQuery>>, TError,{data: Query[];params?: PostDailyRollupMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupMultiQuery>>, TError,{data: Query[];params?: PostDailyRollupMultiQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDailyRollupMultiQuery>>, {data: Query[];params?: PostDailyRollupMultiQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postDailyRollupMultiQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDailyRollupMultiQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postDailyRollupMultiQuery>>>
    export type PostDailyRollupMultiQueryMutationBody = Query[]
    export type PostDailyRollupMultiQueryMutationError = unknown

    export const usePostDailyRollupMultiQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDailyRollupMultiQuery>>, TError,{data: Query[];params?: PostDailyRollupMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDailyRollupMultiQuery>>,
        TError,
        {data: Query[];params?: PostDailyRollupMultiQueryParams},
        TContext
      > => {

      const mutationOptions = getPostDailyRollupMultiQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFocusGetConversionInfo = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ConversionPlanBundle>(
      {url: `/Focus/GetConversionInfo`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetFocusGetConversionInfoQueryKey = () => {
    return [`/Focus/GetConversionInfo`] as const;
    }

    
export const getGetFocusGetConversionInfoQueryOptions = <TData = Awaited<ReturnType<typeof getFocusGetConversionInfo>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFocusGetConversionInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFocusGetConversionInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFocusGetConversionInfo>>> = ({ signal }) => getFocusGetConversionInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFocusGetConversionInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFocusGetConversionInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getFocusGetConversionInfo>>>
export type GetFocusGetConversionInfoQueryError = unknown

export const useGetFocusGetConversionInfo = <TData = Awaited<ReturnType<typeof getFocusGetConversionInfo>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFocusGetConversionInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFocusGetConversionInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postForecastQuery = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/Forecast/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostForecastQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postForecastQuery>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postForecastQuery>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postForecastQuery(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostForecastQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postForecastQuery>>>
    export type PostForecastQueryMutationBody = Query
    export type PostForecastQueryMutationError = unknown

    export const usePostForecastQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postForecastQuery>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostForecastQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postForecastMultiQuery = (
    query: Query[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult[]>(
      {url: `/Forecast/MultiQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostForecastMultiQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastMultiQuery>>, TError,{data: Query[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postForecastMultiQuery>>, TError,{data: Query[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postForecastMultiQuery>>, {data: Query[]}> = (props) => {
          const {data} = props ?? {};

          return  postForecastMultiQuery(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostForecastMultiQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postForecastMultiQuery>>>
    export type PostForecastMultiQueryMutationBody = Query[]
    export type PostForecastMultiQueryMutationError = unknown

    export const usePostForecastMultiQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastMultiQuery>>, TError,{data: Query[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postForecastMultiQuery>>,
        TError,
        {data: Query[]},
        TContext
      > => {

      const mutationOptions = getPostForecastMultiQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postForecastStreamForecast = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/Forecast/StreamForecast`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostForecastStreamForecastMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastStreamForecast>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postForecastStreamForecast>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postForecastStreamForecast>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postForecastStreamForecast(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostForecastStreamForecastMutationResult = NonNullable<Awaited<ReturnType<typeof postForecastStreamForecast>>>
    export type PostForecastStreamForecastMutationBody = Query
    export type PostForecastStreamForecastMutationError = unknown

    export const usePostForecastStreamForecast = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastStreamForecast>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postForecastStreamForecast>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostForecastStreamForecastMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postForecastCreateCostForecast = (
    costForecastRequest: CostForecastRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CostForecastRequestedJob>(
      {url: `/Forecast/CreateCostForecast`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: costForecastRequest
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostForecastCreateCostForecastMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastCreateCostForecast>>, TError,{data: CostForecastRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postForecastCreateCostForecast>>, TError,{data: CostForecastRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postForecastCreateCostForecast>>, {data: CostForecastRequest}> = (props) => {
          const {data} = props ?? {};

          return  postForecastCreateCostForecast(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostForecastCreateCostForecastMutationResult = NonNullable<Awaited<ReturnType<typeof postForecastCreateCostForecast>>>
    export type PostForecastCreateCostForecastMutationBody = CostForecastRequest
    export type PostForecastCreateCostForecastMutationError = unknown

    export const usePostForecastCreateCostForecast = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastCreateCostForecast>>, TError,{data: CostForecastRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postForecastCreateCostForecast>>,
        TError,
        {data: CostForecastRequest},
        TContext
      > => {

      const mutationOptions = getPostForecastCreateCostForecastMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postForecastEstimateCardinality = (
    costForecastRequest: CostForecastRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CardinalityCheckResult>(
      {url: `/Forecast/EstimateCardinality`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: costForecastRequest
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostForecastEstimateCardinalityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastEstimateCardinality>>, TError,{data: CostForecastRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postForecastEstimateCardinality>>, TError,{data: CostForecastRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postForecastEstimateCardinality>>, {data: CostForecastRequest}> = (props) => {
          const {data} = props ?? {};

          return  postForecastEstimateCardinality(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostForecastEstimateCardinalityMutationResult = NonNullable<Awaited<ReturnType<typeof postForecastEstimateCardinality>>>
    export type PostForecastEstimateCardinalityMutationBody = CostForecastRequest
    export type PostForecastEstimateCardinalityMutationError = unknown

    export const usePostForecastEstimateCardinality = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastEstimateCardinality>>, TError,{data: CostForecastRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postForecastEstimateCardinality>>,
        TError,
        {data: CostForecastRequest},
        TContext
      > => {

      const mutationOptions = getPostForecastEstimateCardinalityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postForecastUpsertForecastConfig = (
    forecastConfig: ForecastConfig,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TenantForecastRefreshNeededJob>(
      {url: `/Forecast/UpsertForecastConfig`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forecastConfig
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostForecastUpsertForecastConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastUpsertForecastConfig>>, TError,{data: ForecastConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postForecastUpsertForecastConfig>>, TError,{data: ForecastConfig}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postForecastUpsertForecastConfig>>, {data: ForecastConfig}> = (props) => {
          const {data} = props ?? {};

          return  postForecastUpsertForecastConfig(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostForecastUpsertForecastConfigMutationResult = NonNullable<Awaited<ReturnType<typeof postForecastUpsertForecastConfig>>>
    export type PostForecastUpsertForecastConfigMutationBody = ForecastConfig
    export type PostForecastUpsertForecastConfigMutationError = unknown

    export const usePostForecastUpsertForecastConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForecastUpsertForecastConfig>>, TError,{data: ForecastConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postForecastUpsertForecastConfig>>,
        TError,
        {data: ForecastConfig},
        TContext
      > => {

      const mutationOptions = getPostForecastUpsertForecastConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getForecastGetForecastConfig = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ForecastConfig>(
      {url: `/Forecast/GetForecastConfig`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetForecastGetForecastConfigQueryKey = () => {
    return [`/Forecast/GetForecastConfig`] as const;
    }

    
export const getGetForecastGetForecastConfigQueryOptions = <TData = Awaited<ReturnType<typeof getForecastGetForecastConfig>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastGetForecastConfig>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForecastGetForecastConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecastGetForecastConfig>>> = ({ signal }) => getForecastGetForecastConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForecastGetForecastConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForecastGetForecastConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getForecastGetForecastConfig>>>
export type GetForecastGetForecastConfigQueryError = unknown

export const useGetForecastGetForecastConfig = <TData = Awaited<ReturnType<typeof getForecastGetForecastConfig>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastGetForecastConfig>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetForecastGetForecastConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postInvoiceIngestionIngestReducedBillingFiles = (
    params?: PostInvoiceIngestionIngestReducedBillingFilesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/InvoiceIngestion/IngestReducedBillingFiles`, method: 'POST',
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostInvoiceIngestionIngestReducedBillingFilesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionIngestReducedBillingFiles>>, TError,{params?: PostInvoiceIngestionIngestReducedBillingFilesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionIngestReducedBillingFiles>>, TError,{params?: PostInvoiceIngestionIngestReducedBillingFilesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceIngestionIngestReducedBillingFiles>>, {params?: PostInvoiceIngestionIngestReducedBillingFilesParams}> = (props) => {
          const {params} = props ?? {};

          return  postInvoiceIngestionIngestReducedBillingFiles(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceIngestionIngestReducedBillingFilesMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceIngestionIngestReducedBillingFiles>>>
    
    export type PostInvoiceIngestionIngestReducedBillingFilesMutationError = unknown

    export const usePostInvoiceIngestionIngestReducedBillingFiles = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionIngestReducedBillingFiles>>, TError,{params?: PostInvoiceIngestionIngestReducedBillingFilesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInvoiceIngestionIngestReducedBillingFiles>>,
        TError,
        {params?: PostInvoiceIngestionIngestReducedBillingFilesParams},
        TContext
      > => {

      const mutationOptions = getPostInvoiceIngestionIngestReducedBillingFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postInvoiceIngestionIngestStagedFiles = (
    params?: PostInvoiceIngestionIngestStagedFilesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/InvoiceIngestion/IngestStagedFiles`, method: 'POST',
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostInvoiceIngestionIngestStagedFilesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionIngestStagedFiles>>, TError,{params?: PostInvoiceIngestionIngestStagedFilesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionIngestStagedFiles>>, TError,{params?: PostInvoiceIngestionIngestStagedFilesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceIngestionIngestStagedFiles>>, {params?: PostInvoiceIngestionIngestStagedFilesParams}> = (props) => {
          const {params} = props ?? {};

          return  postInvoiceIngestionIngestStagedFiles(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceIngestionIngestStagedFilesMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceIngestionIngestStagedFiles>>>
    
    export type PostInvoiceIngestionIngestStagedFilesMutationError = unknown

    export const usePostInvoiceIngestionIngestStagedFiles = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionIngestStagedFiles>>, TError,{params?: PostInvoiceIngestionIngestStagedFilesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInvoiceIngestionIngestStagedFiles>>,
        TError,
        {params?: PostInvoiceIngestionIngestStagedFilesParams},
        TContext
      > => {

      const mutationOptions = getPostInvoiceIngestionIngestStagedFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postInvoiceIngestionForwardKafkaMessageForSynapse = (
    exportFilesProcessed: ExportFilesProcessed,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/InvoiceIngestion/ForwardKafkaMessageForSynapse`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportFilesProcessed
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostInvoiceIngestionForwardKafkaMessageForSynapseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionForwardKafkaMessageForSynapse>>, TError,{data: ExportFilesProcessed}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionForwardKafkaMessageForSynapse>>, TError,{data: ExportFilesProcessed}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceIngestionForwardKafkaMessageForSynapse>>, {data: ExportFilesProcessed}> = (props) => {
          const {data} = props ?? {};

          return  postInvoiceIngestionForwardKafkaMessageForSynapse(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceIngestionForwardKafkaMessageForSynapseMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceIngestionForwardKafkaMessageForSynapse>>>
    export type PostInvoiceIngestionForwardKafkaMessageForSynapseMutationBody = ExportFilesProcessed
    export type PostInvoiceIngestionForwardKafkaMessageForSynapseMutationError = unknown

    export const usePostInvoiceIngestionForwardKafkaMessageForSynapse = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceIngestionForwardKafkaMessageForSynapse>>, TError,{data: ExportFilesProcessed}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInvoiceIngestionForwardKafkaMessageForSynapse>>,
        TError,
        {data: ExportFilesProcessed},
        TContext
      > => {

      const mutationOptions = getPostInvoiceIngestionForwardKafkaMessageForSynapseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getInvoiceIngestionGetSchemaInfo = (
    params?: GetInvoiceIngestionGetSchemaInfoParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceSchemaInfo>(
      {url: `/InvoiceIngestion/GetSchemaInfo`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetInvoiceIngestionGetSchemaInfoQueryKey = (params?: GetInvoiceIngestionGetSchemaInfoParams,) => {
    return [`/InvoiceIngestion/GetSchemaInfo`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvoiceIngestionGetSchemaInfoQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceIngestionGetSchemaInfo>>, TError = unknown>(params?: GetInvoiceIngestionGetSchemaInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceIngestionGetSchemaInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceIngestionGetSchemaInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceIngestionGetSchemaInfo>>> = ({ signal }) => getInvoiceIngestionGetSchemaInfo(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceIngestionGetSchemaInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceIngestionGetSchemaInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceIngestionGetSchemaInfo>>>
export type GetInvoiceIngestionGetSchemaInfoQueryError = unknown

export const useGetInvoiceIngestionGetSchemaInfo = <TData = Awaited<ReturnType<typeof getInvoiceIngestionGetSchemaInfo>>, TError = unknown>(
 params?: GetInvoiceIngestionGetSchemaInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceIngestionGetSchemaInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceIngestionGetSchemaInfoQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInvoiceIngestionCreateAwsCur = (
    params?: GetInvoiceIngestionCreateAwsCurParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/InvoiceIngestion/CreateAwsCur`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetInvoiceIngestionCreateAwsCurQueryKey = (params?: GetInvoiceIngestionCreateAwsCurParams,) => {
    return [`/InvoiceIngestion/CreateAwsCur`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvoiceIngestionCreateAwsCurQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceIngestionCreateAwsCur>>, TError = unknown>(params?: GetInvoiceIngestionCreateAwsCurParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceIngestionCreateAwsCur>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceIngestionCreateAwsCurQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceIngestionCreateAwsCur>>> = ({ signal }) => getInvoiceIngestionCreateAwsCur(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceIngestionCreateAwsCur>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceIngestionCreateAwsCurQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceIngestionCreateAwsCur>>>
export type GetInvoiceIngestionCreateAwsCurQueryError = unknown

export const useGetInvoiceIngestionCreateAwsCur = <TData = Awaited<ReturnType<typeof getInvoiceIngestionCreateAwsCur>>, TError = unknown>(
 params?: GetInvoiceIngestionCreateAwsCurParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceIngestionCreateAwsCur>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceIngestionCreateAwsCurQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postInvoiceRuleSaveInvoiceTaggingRule = (
    invoiceTaggingRule: InvoiceTaggingRule,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/InvoiceRule/SaveInvoiceTaggingRule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invoiceTaggingRule
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostInvoiceRuleSaveInvoiceTaggingRuleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceTaggingRule>>, TError,{data: InvoiceTaggingRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceTaggingRule>>, TError,{data: InvoiceTaggingRule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceTaggingRule>>, {data: InvoiceTaggingRule}> = (props) => {
          const {data} = props ?? {};

          return  postInvoiceRuleSaveInvoiceTaggingRule(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceRuleSaveInvoiceTaggingRuleMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceTaggingRule>>>
    export type PostInvoiceRuleSaveInvoiceTaggingRuleMutationBody = InvoiceTaggingRule
    export type PostInvoiceRuleSaveInvoiceTaggingRuleMutationError = unknown

    export const usePostInvoiceRuleSaveInvoiceTaggingRule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceTaggingRule>>, TError,{data: InvoiceTaggingRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceTaggingRule>>,
        TError,
        {data: InvoiceTaggingRule},
        TContext
      > => {

      const mutationOptions = getPostInvoiceRuleSaveInvoiceTaggingRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postInvoiceRuleSaveInvoiceAllocationRule = (
    invoiceAllocationRule: InvoiceAllocationRule,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/InvoiceRule/SaveInvoiceAllocationRule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invoiceAllocationRule
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostInvoiceRuleSaveInvoiceAllocationRuleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceAllocationRule>>, TError,{data: InvoiceAllocationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceAllocationRule>>, TError,{data: InvoiceAllocationRule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceAllocationRule>>, {data: InvoiceAllocationRule}> = (props) => {
          const {data} = props ?? {};

          return  postInvoiceRuleSaveInvoiceAllocationRule(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceRuleSaveInvoiceAllocationRuleMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceAllocationRule>>>
    export type PostInvoiceRuleSaveInvoiceAllocationRuleMutationBody = InvoiceAllocationRule
    export type PostInvoiceRuleSaveInvoiceAllocationRuleMutationError = unknown

    export const usePostInvoiceRuleSaveInvoiceAllocationRule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceAllocationRule>>, TError,{data: InvoiceAllocationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInvoiceRuleSaveInvoiceAllocationRule>>,
        TError,
        {data: InvoiceAllocationRule},
        TContext
      > => {

      const mutationOptions = getPostInvoiceRuleSaveInvoiceAllocationRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postInvoiceRuleSaveAllocationDimension = (
    allocationDimension: AllocationDimension,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/InvoiceRule/SaveAllocationDimension`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: allocationDimension
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostInvoiceRuleSaveAllocationDimensionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveAllocationDimension>>, TError,{data: AllocationDimension}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveAllocationDimension>>, TError,{data: AllocationDimension}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceRuleSaveAllocationDimension>>, {data: AllocationDimension}> = (props) => {
          const {data} = props ?? {};

          return  postInvoiceRuleSaveAllocationDimension(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceRuleSaveAllocationDimensionMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceRuleSaveAllocationDimension>>>
    export type PostInvoiceRuleSaveAllocationDimensionMutationBody = AllocationDimension
    export type PostInvoiceRuleSaveAllocationDimensionMutationError = unknown

    export const usePostInvoiceRuleSaveAllocationDimension = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleSaveAllocationDimension>>, TError,{data: AllocationDimension}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInvoiceRuleSaveAllocationDimension>>,
        TError,
        {data: AllocationDimension},
        TContext
      > => {

      const mutationOptions = getPostInvoiceRuleSaveAllocationDimensionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getInvoiceRuleGetAllocationDimensions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AllocationDimension[]>(
      {url: `/InvoiceRule/GetAllocationDimensions`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetInvoiceRuleGetAllocationDimensionsQueryKey = () => {
    return [`/InvoiceRule/GetAllocationDimensions`] as const;
    }

    
export const getGetInvoiceRuleGetAllocationDimensionsQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceRuleGetAllocationDimensionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensions>>> = ({ signal }) => getInvoiceRuleGetAllocationDimensions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceRuleGetAllocationDimensionsQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensions>>>
export type GetInvoiceRuleGetAllocationDimensionsQueryError = unknown

export const useGetInvoiceRuleGetAllocationDimensions = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceRuleGetAllocationDimensionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInvoiceRuleGetAllocationDimensionsBackend = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AllocationDimension[]>(
      {url: `/InvoiceRule/GetAllocationDimensionsBackend`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetInvoiceRuleGetAllocationDimensionsBackendQueryKey = () => {
    return [`/InvoiceRule/GetAllocationDimensionsBackend`] as const;
    }

    
export const getGetInvoiceRuleGetAllocationDimensionsBackendQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensionsBackend>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensionsBackend>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceRuleGetAllocationDimensionsBackendQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensionsBackend>>> = ({ signal }) => getInvoiceRuleGetAllocationDimensionsBackend(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensionsBackend>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceRuleGetAllocationDimensionsBackendQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensionsBackend>>>
export type GetInvoiceRuleGetAllocationDimensionsBackendQueryError = unknown

export const useGetInvoiceRuleGetAllocationDimensionsBackend = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensionsBackend>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetAllocationDimensionsBackend>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceRuleGetAllocationDimensionsBackendQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInvoiceRuleGetInvoiceAllocationRules = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceAllocationRule[]>(
      {url: `/InvoiceRule/GetInvoiceAllocationRules`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetInvoiceRuleGetInvoiceAllocationRulesQueryKey = () => {
    return [`/InvoiceRule/GetInvoiceAllocationRules`] as const;
    }

    
export const getGetInvoiceRuleGetInvoiceAllocationRulesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceAllocationRules>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceAllocationRules>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceRuleGetInvoiceAllocationRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceAllocationRules>>> = ({ signal }) => getInvoiceRuleGetInvoiceAllocationRules(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceAllocationRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceRuleGetInvoiceAllocationRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceAllocationRules>>>
export type GetInvoiceRuleGetInvoiceAllocationRulesQueryError = unknown

export const useGetInvoiceRuleGetInvoiceAllocationRules = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceAllocationRules>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceAllocationRules>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceRuleGetInvoiceAllocationRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInvoiceRuleGetInvoiceTaggingRules = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceTaggingRule[]>(
      {url: `/InvoiceRule/GetInvoiceTaggingRules`, method: 'GET', signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetInvoiceRuleGetInvoiceTaggingRulesQueryKey = () => {
    return [`/InvoiceRule/GetInvoiceTaggingRules`] as const;
    }

    
export const getGetInvoiceRuleGetInvoiceTaggingRulesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceTaggingRules>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceTaggingRules>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceRuleGetInvoiceTaggingRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceTaggingRules>>> = ({ signal }) => getInvoiceRuleGetInvoiceTaggingRules(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceTaggingRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceRuleGetInvoiceTaggingRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceTaggingRules>>>
export type GetInvoiceRuleGetInvoiceTaggingRulesQueryError = unknown

export const useGetInvoiceRuleGetInvoiceTaggingRules = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceTaggingRules>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetInvoiceTaggingRules>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceRuleGetInvoiceTaggingRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInvoiceRuleGetProcessingReport = (
    params?: GetInvoiceRuleGetProcessingReportParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceProcessingReport>(
      {url: `/InvoiceRule/GetProcessingReport`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetInvoiceRuleGetProcessingReportQueryKey = (params?: GetInvoiceRuleGetProcessingReportParams,) => {
    return [`/InvoiceRule/GetProcessingReport`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvoiceRuleGetProcessingReportQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetProcessingReport>>, TError = unknown>(params?: GetInvoiceRuleGetProcessingReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetProcessingReport>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceRuleGetProcessingReportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceRuleGetProcessingReport>>> = ({ signal }) => getInvoiceRuleGetProcessingReport(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetProcessingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceRuleGetProcessingReportQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceRuleGetProcessingReport>>>
export type GetInvoiceRuleGetProcessingReportQueryError = unknown

export const useGetInvoiceRuleGetProcessingReport = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetProcessingReport>>, TError = unknown>(
 params?: GetInvoiceRuleGetProcessingReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetProcessingReport>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceRuleGetProcessingReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInvoiceRuleGetSystemProcessingReport = (
    params?: GetInvoiceRuleGetSystemProcessingReportParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceProcessingReport>(
      {url: `/InvoiceRule/GetSystemProcessingReport`, method: 'GET',
        params, signal
    },
      { type: 'Invoices',  ...options});
    }
  

export const getGetInvoiceRuleGetSystemProcessingReportQueryKey = (params?: GetInvoiceRuleGetSystemProcessingReportParams,) => {
    return [`/InvoiceRule/GetSystemProcessingReport`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvoiceRuleGetSystemProcessingReportQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetSystemProcessingReport>>, TError = unknown>(params?: GetInvoiceRuleGetSystemProcessingReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetSystemProcessingReport>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceRuleGetSystemProcessingReportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceRuleGetSystemProcessingReport>>> = ({ signal }) => getInvoiceRuleGetSystemProcessingReport(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetSystemProcessingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceRuleGetSystemProcessingReportQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceRuleGetSystemProcessingReport>>>
export type GetInvoiceRuleGetSystemProcessingReportQueryError = unknown

export const useGetInvoiceRuleGetSystemProcessingReport = <TData = Awaited<ReturnType<typeof getInvoiceRuleGetSystemProcessingReport>>, TError = unknown>(
 params?: GetInvoiceRuleGetSystemProcessingReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceRuleGetSystemProcessingReport>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceRuleGetSystemProcessingReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postInvoiceRuleProcessInvoiceData = (
    invoiceProcessData: InvoiceProcessData,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/InvoiceRule/ProcessInvoiceData`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invoiceProcessData
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostInvoiceRuleProcessInvoiceDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleProcessInvoiceData>>, TError,{data: InvoiceProcessData}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleProcessInvoiceData>>, TError,{data: InvoiceProcessData}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceRuleProcessInvoiceData>>, {data: InvoiceProcessData}> = (props) => {
          const {data} = props ?? {};

          return  postInvoiceRuleProcessInvoiceData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceRuleProcessInvoiceDataMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceRuleProcessInvoiceData>>>
    export type PostInvoiceRuleProcessInvoiceDataMutationBody = InvoiceProcessData
    export type PostInvoiceRuleProcessInvoiceDataMutationError = unknown

    export const usePostInvoiceRuleProcessInvoiceData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceRuleProcessInvoiceData>>, TError,{data: InvoiceProcessData}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInvoiceRuleProcessInvoiceData>>,
        TError,
        {data: InvoiceProcessData},
        TContext
      > => {

      const mutationOptions = getPostInvoiceRuleProcessInvoiceDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMDSQuery = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/MDS/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostMDSQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMDSQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMDSQuery>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMDSQuery>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postMDSQuery(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMDSQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postMDSQuery>>>
    export type PostMDSQueryMutationBody = Query
    export type PostMDSQueryMutationError = unknown

    export const usePostMDSQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMDSQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMDSQuery>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostMDSQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMDSStream = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/MDS/Stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostMDSStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMDSStream>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMDSStream>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMDSStream>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postMDSStream(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMDSStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postMDSStream>>>
    export type PostMDSStreamMutationBody = Query
    export type PostMDSStreamMutationError = unknown

    export const usePostMDSStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMDSStream>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMDSStream>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostMDSStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMDSMultiQuery = (
    query: Query[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult[]>(
      {url: `/MDS/MultiQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostMDSMultiQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMDSMultiQuery>>, TError,{data: Query[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMDSMultiQuery>>, TError,{data: Query[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMDSMultiQuery>>, {data: Query[]}> = (props) => {
          const {data} = props ?? {};

          return  postMDSMultiQuery(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMDSMultiQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postMDSMultiQuery>>>
    export type PostMDSMultiQueryMutationBody = Query[]
    export type PostMDSMultiQueryMutationError = unknown

    export const usePostMDSMultiQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMDSMultiQuery>>, TError,{data: Query[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMDSMultiQuery>>,
        TError,
        {data: Query[]},
        TContext
      > => {

      const mutationOptions = getPostMDSMultiQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMonthlyRollupQuery = (
    query: Query,
    params?: PostMonthlyRollupQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/MonthlyRollup/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostMonthlyRollupQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupQuery>>, TError,{data: Query;params?: PostMonthlyRollupQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupQuery>>, TError,{data: Query;params?: PostMonthlyRollupQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMonthlyRollupQuery>>, {data: Query;params?: PostMonthlyRollupQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postMonthlyRollupQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMonthlyRollupQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postMonthlyRollupQuery>>>
    export type PostMonthlyRollupQueryMutationBody = Query
    export type PostMonthlyRollupQueryMutationError = unknown

    export const usePostMonthlyRollupQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupQuery>>, TError,{data: Query;params?: PostMonthlyRollupQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMonthlyRollupQuery>>,
        TError,
        {data: Query;params?: PostMonthlyRollupQueryParams},
        TContext
      > => {

      const mutationOptions = getPostMonthlyRollupQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMonthlyRollupStream = (
    query: Query,
    params?: PostMonthlyRollupStreamParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/MonthlyRollup/Stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostMonthlyRollupStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupStream>>, TError,{data: Query;params?: PostMonthlyRollupStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupStream>>, TError,{data: Query;params?: PostMonthlyRollupStreamParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMonthlyRollupStream>>, {data: Query;params?: PostMonthlyRollupStreamParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postMonthlyRollupStream(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMonthlyRollupStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postMonthlyRollupStream>>>
    export type PostMonthlyRollupStreamMutationBody = Query
    export type PostMonthlyRollupStreamMutationError = unknown

    export const usePostMonthlyRollupStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupStream>>, TError,{data: Query;params?: PostMonthlyRollupStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMonthlyRollupStream>>,
        TError,
        {data: Query;params?: PostMonthlyRollupStreamParams},
        TContext
      > => {

      const mutationOptions = getPostMonthlyRollupStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMonthlyRollupMultiQuery = (
    query: Query[],
    params?: PostMonthlyRollupMultiQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult[]>(
      {url: `/MonthlyRollup/MultiQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostMonthlyRollupMultiQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupMultiQuery>>, TError,{data: Query[];params?: PostMonthlyRollupMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupMultiQuery>>, TError,{data: Query[];params?: PostMonthlyRollupMultiQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMonthlyRollupMultiQuery>>, {data: Query[];params?: PostMonthlyRollupMultiQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postMonthlyRollupMultiQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMonthlyRollupMultiQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postMonthlyRollupMultiQuery>>>
    export type PostMonthlyRollupMultiQueryMutationBody = Query[]
    export type PostMonthlyRollupMultiQueryMutationError = unknown

    export const usePostMonthlyRollupMultiQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonthlyRollupMultiQuery>>, TError,{data: Query[];params?: PostMonthlyRollupMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMonthlyRollupMultiQuery>>,
        TError,
        {data: Query[];params?: PostMonthlyRollupMultiQueryParams},
        TContext
      > => {

      const mutationOptions = getPostMonthlyRollupMultiQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResaleCostQuery = (
    query: Query,
    params?: PostResaleCostQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/ResaleCost/Query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostResaleCostQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResaleCostQuery>>, TError,{data: Query;params?: PostResaleCostQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResaleCostQuery>>, TError,{data: Query;params?: PostResaleCostQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResaleCostQuery>>, {data: Query;params?: PostResaleCostQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResaleCostQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResaleCostQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postResaleCostQuery>>>
    export type PostResaleCostQueryMutationBody = Query
    export type PostResaleCostQueryMutationError = unknown

    export const usePostResaleCostQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResaleCostQuery>>, TError,{data: Query;params?: PostResaleCostQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResaleCostQuery>>,
        TError,
        {data: Query;params?: PostResaleCostQueryParams},
        TContext
      > => {

      const mutationOptions = getPostResaleCostQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResaleCostStream = (
    query: Query,
    params?: PostResaleCostStreamParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<unknown[]>(
      {url: `/ResaleCost/Stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostResaleCostStreamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResaleCostStream>>, TError,{data: Query;params?: PostResaleCostStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResaleCostStream>>, TError,{data: Query;params?: PostResaleCostStreamParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResaleCostStream>>, {data: Query;params?: PostResaleCostStreamParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResaleCostStream(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResaleCostStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postResaleCostStream>>>
    export type PostResaleCostStreamMutationBody = Query
    export type PostResaleCostStreamMutationError = unknown

    export const usePostResaleCostStream = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResaleCostStream>>, TError,{data: Query;params?: PostResaleCostStreamParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResaleCostStream>>,
        TError,
        {data: Query;params?: PostResaleCostStreamParams},
        TContext
      > => {

      const mutationOptions = getPostResaleCostStreamMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postResaleCostMultiQuery = (
    query: Query[],
    params?: PostResaleCostMultiQueryParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult[]>(
      {url: `/ResaleCost/MultiQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query,
        params
    },
      { type: 'Invoices',  ...options});
    }
  


export const getPostResaleCostMultiQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResaleCostMultiQuery>>, TError,{data: Query[];params?: PostResaleCostMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResaleCostMultiQuery>>, TError,{data: Query[];params?: PostResaleCostMultiQueryParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResaleCostMultiQuery>>, {data: Query[];params?: PostResaleCostMultiQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postResaleCostMultiQuery(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResaleCostMultiQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postResaleCostMultiQuery>>>
    export type PostResaleCostMultiQueryMutationBody = Query[]
    export type PostResaleCostMultiQueryMutationError = unknown

    export const usePostResaleCostMultiQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResaleCostMultiQuery>>, TError,{data: Query[];params?: PostResaleCostMultiQueryParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResaleCostMultiQuery>>,
        TError,
        {data: Query[];params?: PostResaleCostMultiQueryParams},
        TContext
      > => {

      const mutationOptions = getPostResaleCostMultiQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
